import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import translationEN from '../translations/en.json';
import translationFI from '../translations/fi.json';
import translationSV from '../translations/sv.json';

declare module 'i18next' {}

i18n
	// detect user language
	// learn more: https://github.com/i18next/i18next-browser-languageDetector
	.use(LanguageDetector)
	// pass the i18n instance to the react-i18next components.
	// Alternative use the I18nextProvider: https://react.i18next.com/components/i18nextprovider
	.use(initReactI18next)
	// init i18next
	// for all options read: https://www.i18next.com/overview/configuration-options
	.init({
		fallbackLng: 'fi',
		supportedLngs: ['en', 'fi', 'sv'],
		load: 'languageOnly',
		debug: false,
		returnNull: false,
		interpolation: {
			escapeValue: false, // not needed for react as it escapes by default
		},
		saveMissing: true,
		missingKeyHandler: function (lng, ns, key) {
			console.error(
				`Missing translation key: ${key} in namespace: ${ns} for language: ${lng}`,
			);
		},
		resources: {
			en: {
				translation: translationEN,
			},
			fi: {
				translation: translationFI,
			},
			sv: {
				translation: translationSV,
			},
		},

		// special options for react-i18next
		// learn more: https://react.i18next.com/components/i18next-instance
		react: {
			useSuspense: false,
		},
	});

export default i18n;
